// extracted by mini-css-extract-plugin
module.exports = {"messageContent":"Logout_messageContent__1kWvH","message":"Logout_message__1CKHT","providerLogo":"Logout_providerLogo__bWwKW","button":"Logout_button__tFqN8"};